import React from 'react';
import { DocumentAuditTimeline } from '../../DocumentAuditTimeline';
import { DocumentHistoryModalShell } from './DocumentHistoryModalShell';

interface DocumentAuditHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentId: string;
  documentTitle: string;
}

export const DocumentAuditHistoryModal: React.FC<DocumentAuditHistoryModalProps> = ({
  isOpen,
  onClose,
  documentId,
  documentTitle,
}) => {
  return (
    <DocumentHistoryModalShell
      isOpen={isOpen}
      onClose={onClose}
      documentTitle={documentTitle}
      title="Auditoria do documento"
    >
      <DocumentAuditTimeline documentId={documentId} variant="embedded" />
    </DocumentHistoryModalShell>
  );
};
